import React, { useState } from 'react';
import './ErrorPage.css';

interface ErrorPageProps {
  title: string;
  message: string;
  onClose?: () => void;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ title, message, onClose }) => {
  const [closing, setClosing] = useState(false);

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      onClose?.();
    }, 300);
  };

  return (
    <div className={`error-modal-overlay ${closing ? 'closing' : ''}`}>
      <div className={`error-modal ${closing ? 'slide-down' : ''}`}>
        <button
          className="error-modal-close"
          onClick={handleClose}
          aria-label="Close modal"
        >
          ×
        </button>
        <div className="error-modal-icon">
          <img src="/images/error-cross-icon.png" alt="Error Icon" />
        </div>
        <h1 className="error-modal-title">{title}</h1>
        <p className="error-modal-message">{message}</p>
        <button className="error-modal-button" onClick={handleClose}>
          D’acord
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;
